import React from 'react'

export default function Sorting({ sort, handleSort, column, defaultSorting }) {
  return (
    <div onClick={(e) => { handleSort(e, column) }} className={`e_none cp ${sort.order}`}>
      {

        defaultSorting ?
          <i className=" text-muted fas fa-sort-down"></i>
          :
          sort.column === column ?

            sort.order === "ascending" ?
              <i className=" text-muted fas fa-sort-up"></i>
              :
              <i className=" text-muted fas fa-sort-down"></i>

            :
            <i className=" text-muted fas fa-sort"></i>
      }

    </div>
  )
}
